import { HttpClient, HttpHeaders, HttpRequest, HttpHeaderResponse } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {Helper} from 'src/app/shared/Helper';

export class ServiceBase {
  private token: string;
  //private baseApiUrl = 'https://api.facinatus.net/';
  //private baseApiUrl = "http://facinatus.prod.api.simplifica.top/"
  //private baseApiUrl = 'http://localhost:5020/';
  //private baseApiUrl = 'http://localhost:5021/';
  //public baseApiUrl = "http://facinatus.homolog.api.simplifica.top/"
  constructor(private http: HttpClient) {
    this.http = http;
    this.token = localStorage.getItem("jwt");
  }
  public GetValue<T>(param: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<T>(Helper.baseApiUrl + param, httpOptions).pipe(
      catchError(this.handleError<T>("GetValue"))
    );
  }
  public GetPDF<T>(param: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post(Helper.baseApiUrl + param, httpOptions, { responseType: 'blob' }).pipe(
      catchError(this.handleError("GetValue"))
    );
  }
  public DeleteValue<T>(param: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };
    return this.http.delete<T>(Helper.baseApiUrl + param, httpOptions).pipe(
      catchError(this.handleError<T>("DeleteValue"))
    );
  }

  public SetValue(param: string, obj: any) {

    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(Helper.baseApiUrl + param, obj, httpOptions).pipe(
      catchError(this.handleError("SetValue", obj))
    );
  }

  public ExternalPost(param: string, obj: any) {

    const httpOptions = {
      headers: new HttpHeaders({
        // "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(param, obj, httpOptions).pipe(
      catchError(this.handleError("ExternalPost", obj))
    );
  }

  public UpdateValue(param: string, obj: any) {

    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };



    return this.http.put(Helper.baseApiUrl + param, obj, httpOptions).pipe(
      catchError(this.handleError("SetValue", obj))
    );
  }

  public UploadFile(param: string, obj: any) {


    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        //'Content-Type': 'application/json'
      })
    };
    const uploadReq = new HttpRequest('POST', Helper.baseApiUrl + param, obj, {
      headers: httpOptions.headers, reportProgress: true
    });



    return this.http.request(uploadReq).pipe(
      catchError(this.handleError("UploadFile", obj))
    );
  }



  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}